import { API_URL } from '@hellodarwin/core/lib/api';
import { useLogin } from '@hellodarwin/app-core/lib/providers/login-provider';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useMemo } from 'react';
import { ApiClient } from '../../../api/api';
import { AssistantAPI } from '../services/AssistantAPI';
export const useApiUrl = () => {
    const { app } = usePlatform();
    return useMemo(() => `${API_URL}/${app}`, [app]);
};
export const useAssistantApi = () => {
    const { accessToken } = useLogin();
    const baseApiUrl = useApiUrl();
    return useMemo(() => {
        return new AssistantAPI(new ApiClient({ accessToken, baseApiUrl }));
    }, [accessToken, baseApiUrl]);
};
